import { render, staticRenderFns } from "./OneTab.vue?vue&type=template&id=87d90e9e&scoped=true&"
import script from "./OneTab.vue?vue&type=script&lang=ts&"
export * from "./OneTab.vue?vue&type=script&lang=ts&"
import style0 from "./OneTab.vue?vue&type=style&index=0&id=87d90e9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d90e9e",
  null
  
)

export default component.exports